"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Checkbox_1 = __importDefault(require("../../../Checkbox"));
function BaseColumns({ columnDefinitions, styles, onColumnChange, columns, title, }) {
    return (react_1.default.createElement("div", { className: styles.verticalGrid },
        react_1.default.createElement("b", null, title),
        columnDefinitions
            .filter((c) => typeof c.id != 'undefined')
            .map((c) => (react_1.default.createElement("div", { key: c.id },
            react_1.default.createElement(Checkbox_1.default, { onChange: () => onColumnChange(c.id), checked: !!columns[c.id] }, c.Header))))));
}
exports.default = BaseColumns;
//# sourceMappingURL=index.js.map